import { KeyValueObject } from '@/interfaces/app/ValueObjects'

export interface DetailAdvertisement {
  id: number
  uid: string
  created: string
  price: string
  priceRough: string
  priceModified: string
  priceNote: string
  url: string
  properties?: KeyValueObject[]
}

export interface DetailData {
  properties: KeyValueObject[]
  instances: KeyValueObject[]
  advertisements: DetailAdvertisement[]
  images: Array<{ url: string; alt: string }>
}

export const TestDetailData: DetailData = {
  properties: [
    { key: 'Místnosti', value: 3 },
    { key: 'Podlaží', value: '11.' },
    { key: 'Užitná plocha', value: '47 m²' },
    { key: 'Plocha terasy', value: '4 m²' },
    { key: 'Konstrukce', value: 'panel' },
    { key: 'Počet kuchyní', value: 1 },
    { key: 'Počet podlaží', value: 13 },
    { key: 'Plocha podlahy', value: '48 m²' },
    { key: 'Plocha sklepa', value: '5 m²' },
    { key: 'Energetická náročnost', value: 'G' },
  ],
  instances: [
    { key: 'Případ', value: 'prodej' },
    { key: 'Období', value: '26. 9. 2018 - 5. 11. 2018' },
    { key: 'Stav', value: 'N/A' },
    { key: 'Cena', value: '4 100 000 Kč' },
    {
      key: 'Pozn. k ceně',
      value: '4 100 000 Kč za nemovitost + provize RK',
    },
    { key: 'Vlastnictví', value: 'Osobní' },
    { key: 'Relevantní', value: 'ano' },
    { key: 'Uzavřeno', value: 'ne' },
    { key: 'Inzerátů', value: 2 },
  ],
  advertisements: [
    {
      id: 536001,
      uid: '#379031',
      created: '21. října 2018 1:54',
      price: '4 100 000 Kč',
      priceRough: '4 100 000 Kč',
      priceModified: '5 243 043 Kč',
      priceNote: '4 100 000 Kč za nemovitost + provize RK',
      url:
        'https://www.sreality.cz/detail/prodej/byt/2+1/praha-cast-obce-chodov-ulice-tererova/2421341788',
      properties: [
        { key: 'Název', value: 'Prodej bytu 2+1 47 m²' },
        {
          key: 'Adresa',
          value: 'Tererova 1350/7, Chodov, Praha 11 149 00, Česká Republika',
        },
        { key: 'Souřadnice', value: '50.023643, 14.52225' },
        { key: 'Relevantní', value: 'Ano' },
        {
          key: 'Popis',
          value:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem debitis expedita recusandae veritatis, obcaecati itaque, necessitatibus praesentium eligendi consequatur eius delectus totam alias id dignissimos. Aspernatur exercitationem voluptatem quam laboriosam.',
        },
        { key: 'Platnost', value: '26.9.2018 - 5.11.2018' },
      ],
    },
    {
      id: 536002,
      uid: '#379032',
      created: '21. října 2018 1:54',
      price: '5 100 000 Kč',
      priceRough: '5 100 000 Kč',
      priceModified: '5 243 043 Kč',
      priceNote: '5 100 000 Kč za nemovitost + provize RK',
      url:
        'https://www.sreality.cz/detail/prodej/byt/2+1/praha-cast-obce-chodov-ulice-tererova/2421341789',
      properties: [
        { key: 'Název', value: 'Prodej bytu 2+1 47 m²' },
        {
          key: 'Adresa',
          value: 'Tererova 1350/7, Chodov, Praha 11 149 00, Česká Republika',
        },
        { key: 'Souřadnice', value: '50.023643, 14.52225' },
        { key: 'Relevantní', value: 'Ano' },
        {
          key: 'Popis',
          value:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem debitis expedita recusandae veritatis, obcaecati itaque, necessitatibus praesentium eligendi consequatur eius delectus totam alias id dignissimos. Aspernatur exercitationem voluptatem quam laboriosam.',
        },
        { key: 'Platnost', value: '26.9.2018 - 5.11.2018' },
      ],
    },
    {
      id: 536003,
      uid: '#379033',
      created: '21. října 2018 1:54',
      price: '6 100 000 Kč',
      priceRough: '6 100 000 Kč',
      priceModified: '4 243 043 Kč',
      priceNote: '6 100 000 Kč za nemovitost + provize RK',
      url:
        'https://www.sreality.cz/detail/prodej/byt/2+1/praha-cast-obce-chodov-ulice-tererova/2421341799',
      properties: [
        { key: 'Název', value: 'Prodej bytu 2+1 47 m²' },
        {
          key: 'Adresa',
          value: 'Tererova 1350/7, Chodov, Praha 11 149 00, Česká Republika',
        },
        { key: 'Souřadnice', value: '50.023643, 14.52225' },
        { key: 'Relevantní', value: 'Ano' },
        {
          key: 'Popis',
          value:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem debitis expedita recusandae veritatis, obcaecati itaque, necessitatibus praesentium eligendi consequatur eius delectus totam alias id dignissimos. Aspernatur exercitationem voluptatem quam laboriosam.',
        },
        { key: 'Platnost', value: '26.9.2018 - 5.11.2018' },
      ],
    },
  ],
  images: [
    { url: 'https://randomuser.me/api/portraits/men/21.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/22.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/23.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/24.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/25.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/26.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/27.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/28.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/29.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/30.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/31.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/32.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/33.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/34.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/35.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/36.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/37.jpg', alt: '' },
    { url: 'https://randomuser.me/api/portraits/men/38.jpg', alt: '' },
  ],
}
